<template>
    <div>
        <div class="index_wrap fc">
            <div class="content">
                <div class="item" v-for="(item, index) in arr" :key="index">{{index}}</div>
            </div>
            <div class="footer center">footer</div>
        </div>
    </div>
</template>

<script>
import tabBar from "../../components/common/tabBar.vue";
export default {
    data() {
        return {
            arr: [1,1,1,1,1,1]
        };
    },
    components: {
        tabBar
    },
    created() {},
    methods: {}
};
</script>
<style lang="scss">
.index_wrap {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    .content {
        width: 100%;
        max-height: calc(100vh - 100px);
        overflow-y: scroll;
        .item {
            width: 100%;
            height: 300px;
            border-bottom: 1px solid #eee;
            background: pink;
            display: inline-block;
        }
    }
    .footer {
        width: 100%;
        height: 100px;
        background: lightblue;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue